
import { Strings } from '../../../../utils/resources/strings';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { GroupDtoImpl, GroupDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/groupdto';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import { GroupComponentProps, GroupComponentState , GroupHandler } from './groupcomponent';
import { GroupCSSStyle } from './groupcss';
import * as React from 'react';
import { MemberDetailsDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
// import { ManageGroupComponent } from './managegroup/managegroupcomponent';
import { ListGroupComponent, ListGroupComponentHandler } from './listgroup/listgroupcomponent';
import { ManageGroupType } from './managegroup/managegrouptype';
import { ManageGroupComponent } from './managegroup/managegroupcomponent';

export class GroupViewImpl extends CRBTUIViewImpl
{
    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(applicationContext, uiComponentHandler);
    }
    
    bindHandlers()
    {
        this.onCancelClicked = this.onCancelClicked.bind(this);
        this.onCreateButtonClicked = this.onCreateButtonClicked.bind(this);
        this.onBackClicked = this.onBackClicked.bind(this);
        this.onViewButtonClicked = this.onViewButtonClicked.bind(this);
        this.onEditButtonClicked = this.onEditButtonClicked.bind(this);
        this.onDeleteButtonClick = this.onDeleteButtonClick.bind(this);
    }

    getChildComponent(props: GroupComponentProps, state: GroupComponentState, cssStyle: GroupCSSStyle): JSX.Element
    {   
        return (
            <>
            { 
                state.manageGroupType === ManageGroupType.LIST && <ListGroupComponent onDeleteButtonClick={this.onDeleteButtonClick} onEditButtonClick={this.onEditButtonClicked} onViewButtonClick={this.onViewButtonClicked} onCreateButtonClick={this.onCreateButtonClicked} context={props.context}/>}        
            {
                state.manageGroupType !== ManageGroupType.LIST && <ManageGroupComponent onBackClicked={this.onBackClicked} groupDto={state.groupDto} onCancelClicked={this.onCancelClicked} manageGroupType={state.manageGroupType} context={props.context}/>}
            
            </>
        );
    }

    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.myaccount),
             this.getUIProps().context.getResources().getString(Strings.caller_group)];
    }

    getBannerImg()
    {
        return "categories.jpg";
    }

    private onCreateButtonClicked()
    {
        (this.getUIComponentHandler() as GroupHandler).updateType(ManageGroupType.CREATE, this.getCreateGroupDto());
    }

    private onDeleteButtonClick(groupDto:GroupDto)
    {
        (this.getUIComponentHandler() as ListGroupComponentHandler).onDeleteButtonClick(groupDto);
    }
    private onViewButtonClicked(groupDto:GroupDto)
    {
        groupDto.getMembersList().unshift(new MemberDetailsDtoImpl());
        (this.getUIComponentHandler() as GroupHandler).updateType(ManageGroupType.VIEW,groupDto);
    }

    private onEditButtonClicked(groupdto:GroupDto)
    {
        groupdto.getMembersList().unshift(new MemberDetailsDtoImpl());
        (this.getUIComponentHandler() as GroupHandler).updateType(ManageGroupType.EDIT, groupdto);
    }
    
    private onCancelClicked()
    {
        (this.getUIComponentHandler() as GroupHandler).updateType(ManageGroupType.LIST, (this.getUIState() as GroupComponentState).groupDto);
    }

    private onBackClicked()
    {
        (this.getUIComponentHandler() as GroupHandler).updateType(ManageGroupType.LIST, (this.getUIState() as GroupComponentState).groupDto);
    }

    private getCreateGroupDto()
    {
        let groupDto = new GroupDtoImpl();
        groupDto.setGroupName("");
       
        groupDto.setMembersList([new MemberDetailsDtoImpl()]);

        return groupDto;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/groupview.tsx